/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BudgetDto } from '../../models/budget-dto';
import { CreateBudgetRequest } from '../../models/create-budget-request';

export interface CreateBudget$Params {
      body: CreateBudgetRequest
}

export function createBudget(http: HttpClient, rootUrl: string, params: CreateBudget$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDto>> {
  const rb = new RequestBuilder(rootUrl, createBudget.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BudgetDto>;
    })
  );
}

createBudget.PATH = '/v0/budgets/{id}';
